export const ON = 700
export const MODEL = 800
export const BIND = 850
export const TRANSITION = 1100
export const EL = 1500
export const COMPONENT = 1500
export const PARTIAL = 1750
export const IF = 2100
export const FOR = 2200
export const SLOT = 2300



//////////////////
// WEBPACK FOOTER
// ./~/vue/src/directives/priorities.js
// module id = ./node_modules/vue/src/directives/priorities.js
// module chunks = 53